<div class="individual-subheader" id="veboticket-subhead">
  <div class="container-fluid">
    <div class="vebo_registry_top">
      <h5><strong>SPUR</strong> TICKETING</h5>
      @if(authUser?.role_id==1 || authUser?.role_id==2 || authUser?.role_id==3 || authUser?.role_id==5){
        <a [routerLink]="['/my-profile']">RETURN TO REGISTRY</a>
      }
      @if(authUser?.role_id==4){
        <a [routerLink]="['/my-profile']">RETURN TO PROFILE</a>
      }
    </div>
    <nav class="navbar navbar-expand-lg">
      <div class="wedding-couple-menu-toggle d-lg-none" id="veboticket-menu-toggle">
        Menu
        <i class="fas fa-long-arrow-down"></i>
      </div>
      <div class="navbar-collapse" id="veboticketNav" hidden>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/our-tickets']">OUR TICKETS</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/ticket-category']">ALL EVENTS</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/ticket-evolution-category/concerts']"> CONCERTS</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/ticket-evolution-category/sports']"> SPORTS</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/ticket-evolution-category/theatre']">THEATER</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
	<!-- <div class="custom_new_teag">
        E-WALLET TOTAL:
        <br>
        <strong>$1,088.00</strong>
    </div> -->
</div>
